import { RootState, useAppSelector } from '..';

export const selectVerifyMachine = (state: RootState) => state.verifyMachine;
export const useVerifyMachine = () => useAppSelector(selectVerifyMachine);
